import React, { useEffect, useState } from 'react';
import { ArrowUpIcon } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';
export function BackToTop() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const label = en ? 'Back to top' : ru ? 'Наверх' : 'Nazad na vrh';
  return <button type="button" onClick={handleClick} aria-label={label} className={`fixed bottom-5 left-5 z-40 w-11 h-11 rounded-full bg-dark-surface/90 backdrop-blur border border-brand-yellow/60 text-brand-yellow flex items-center justify-center shadow-md transition-all duration-300 hover:scale-110 hover:border-brand-yellow hover:shadow-[0_0_15px_rgba(255,184,0,0.4)] ${visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'}`} data-id="element-310">
      <ArrowUpIcon className="w-5 h-5" data-id="element-311" />
    </button>;
}